<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)"
             :before-close="beforeClose" class="dialog-w30">
    <template v-if="visible">
      <h2 class="text-center my-0">{{title}}</h2>
      <div class="text-center text-secondary mt-2">Действие не может быть отменено</div>

      <div class="row mt-5">
        <div class="col-12 col-sm-6">
          <el-button class="w-100" @click="$emit('update:visible', false)">Отменить</el-button>
        </div>
        <div class="col-12 col-sm-6 mt-2 mt-sm-0">
          <el-button class="w-100" type="danger" :loading="progress" @click="$emit('onDelete')">Удалить</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    progress: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Вы действительно хотите удалить?',
    },
  },
  methods: {
    beforeClose(done) {
      if (!this.progress) {
        done();
      }
    },
  },
};
</script>
